import './LeadersTable.css';

function LeadersTable(props) {
  return (
    <div className="leaders-table">
      {props.children}
    </div>
  );
}

export default LeadersTable;
